module.exports = __webpack_public_path__ + "static/media/env.408d35ed.png";